export const PAGE_SIZES = [3, 5, 10, 15, 50, 100];

export interface IPaginatorState {
  page: number;
  pageSize: number;
  total: number;
  isPaging: boolean;
  recalculatePaginator(total: number, numberInPage: number): IPaginatorState;
}

export class PaginatorState implements IPaginatorState {
  constructor() {
    this.displayChoose = true;
  }
  page = 1;
  pageSize = PAGE_SIZES[2];
  total = 0;
  isPaging = true;
  pageSizes: number[] = [];
  displayChoose: boolean;
  numberInPage: number;
  recalculatePaginator(total: number, numberInPage: number): PaginatorState {
    this.total = total;
    this.numberInPage = numberInPage;
    return this;
  }
}

export interface IPaginatorView {
  paginator: PaginatorState;
  ngOnInit(): void;
  paginate(paginator: PaginatorState): void;
}
